import React from 'react';
import CheckboxTree from 'react-checkbox-tree';
import { ReactComponent as IconCheck } from '../assets/check.svg';
import { ReactComponent as IconUncheck } from '../assets/uncheck.svg';
import { ReactComponent as IconHalfCheck } from '../assets/half-check.svg';
import { ReactComponent as IconExpandClose } from '../assets/expand-close.svg';
import { ReactComponent as IconExpandOpen } from '../assets/expand-open.svg';

import updateLayerVisibility from '../utils/updateLayerVisibility';

const Sidebar = ({
  mapbox, nodes, checked, setChecked, expanded, setExpanded
}) => {
  const onCheck = (check) => {
    updateLayerVisibility(mapbox, check, checked);
    setChecked(check);
  };

  const onExpand = (expand) => setExpanded(expand);

  return (
    <section className='sidebar'>
      <div className='sidebar-container'>
        <div className='sidebar-content'>
          <CheckboxTree
            nodes={nodes}
            checked={checked}
            expanded={expanded}
            onCheck={onCheck}
            onExpand={onExpand}
            nativeCheckboxes={true}
            icons={{
              check: <IconCheck />,
              uncheck: <IconUncheck />,
              halfCheck: <IconHalfCheck />,
              expandClose: <IconExpandClose />,
              expandOpen: <IconExpandOpen />
            }}
          />
        </div>
      </div>
      <div className='sidebar-legend'>
        <div className='sidebar-item sidebar-item__comerç'>Comerç</div>
        <div className='sidebar-item sidebar-item__eix-sarria'>Comerç d’Eix Sarrià</div>
        <div className='sidebar-item sidebar-item__espai-public'>Espai públic</div>
        <div className='sidebar-item sidebar-item__oci'>Oci i cultura</div>
        <div className='sidebar-item sidebar-item__equipaments'>Equipaments socio-sanitaris</div>
        <div className='sidebar-item sidebar-item__equipaments'>Centres de formació</div>

      </div>
    </section>
  );
};

export default Sidebar;
